var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrongAnswerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#FAAFAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10822 11.4589C5.96393 11.6032 5.96393 11.8437 6.10822 11.988C6.25251 12.1323 6.49299 12.1323 6.63727 11.988L11.8918 6.63727C12.0361 6.49299 12.0361 6.25251 11.8918 6.10822C11.7475 5.96393 11.507 5.96393 11.3627 6.10822L6.10822 11.4589Z",
    fill: "#021A04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3627 11.988C11.507 12.1323 11.7475 12.1323 11.8918 11.988C12.0361 11.8437 12.0361 11.6032 11.8918 11.4589L6.63727 6.10822C6.49299 5.96393 6.25251 5.96393 6.10822 6.10822C5.96393 6.25251 5.96393 6.49299 6.10822 6.63727L11.3627 11.988Z",
    fill: "#021A04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongAnswerIcon);
export default __webpack_public_path__ + "static/media/WrongAnswerIcon.70834c7cb50e3dc3a7279a82e4332a1a.svg";
export { ForwardRef as ReactComponent };